module.exports = __webpack_public_path__ + "img/add-photo-sixth-icon.21e140d4.svg";